import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subject } from 'rxjs';

/**
 * @author Hugo Andrés Escobar Ciceri
 * @version 2.1.0
 *
 * Alert Service to send and receive messages by types.
 */
@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private subject = new Subject();
  private keepAfterNavigationChange = false;

  /**
   *
   * @param router {Router}
   */
  constructor(private router: Router) {
    // clear alert message on route change
    router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterNavigationChange) {
          // only keep for a single location change
          this.keepAfterNavigationChange = false;
        } else {
          // clear alert
          this.subject.next(null);
        }
      }
    });
  }

  /**
   *
   * @param message {string} Message to show on the alert
   * @param link {any} Optional link to add on the alert button
   * @param keepAfterNavigationChange {boolean} only keep for a single location change
   *
   * Function to show alert when is a success message
   */
  success(
    message: string,
    link: any = null,
    keepAfterNavigationChange = false
  ) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.subject.next({ type: 'success', text: message, link: link });
  }

  /**
   *
   * @param message {string} Message to show on the alert
   * @param link {any} Optional link to add on the alert button
   * @param keepAfterNavigationChange {boolean} only keep for a single location change
   *
   * Function to show alert when is a warning message
   */
  warning(
    message: string,
    link: any = null,
    keepAfterNavigationChange = false
  ) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.subject.next({ type: 'warning', text: message, link: link });
  }

  /**
   *
   * @param message {string} Message to show on the alert
   * @param link {any} Optional link to add on the alert button
   * @param keepAfterNavigationChange {boolean} only keep for a single location change
   *
   * Function to show alert when is an error message
   */
  error(message: string, link: any = null, keepAfterNavigationChange = false) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.subject.next({ type: 'error', text: message, link: link });
  }

  /**
   *
   * @param message {string} Message to show on the alert
   * @param link {any} Optional link to add on the alert button
   * @param keepAfterNavigationChange {boolean} only keep for a single location change
   *
   * Function to show alert when is an error message
   */
   inform(message: string, link: any = null, keepAfterNavigationChange = false) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.subject.next({ type: 'info', text: message });
    //this.router.navigate(link.path)
  }


  /**
   * @returns Observable {any}
   *
   * Function to read the message from Subject and return an Observable.
   */
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}
